import { Stack } from 'canoe';
import React from 'react';

import { useAnalyticsQueryParams } from '@candu-ai/analytics/search';
import { QueryId } from '@candu-ai/analytics/types';
import { HistogramGraph } from 'craft/containers/Toolbox/tabs/InteractionAnalytics/HistogramGraph';
import { useTooltipMultiseriesApi } from 'dashboard/pages/Content/pages/Analytics/useTooltipMultiseriesApi';

import { Generic } from './Generic';

interface Props {
  documentNodeId: string;
  contentId: string;
}

export const Checklist = ({ contentId, documentNodeId }: Props) => {
  const queryParams = useAnalyticsQueryParams({
    contentId,
  });

  const queryParamsWithNodeId = useAnalyticsQueryParams({
    documentNodeId,
    contentId,
  });

  const multiseriesApi = useTooltipMultiseriesApi(
    QueryId.NodeChildLabelsTable,
    queryParamsWithNodeId,
  );

  if (!multiseriesApi.hasLoaded()) {
    return null;
  }

  return (
    <Stack spaceAfter="xl">
      <HistogramGraph
        queryId={QueryId.ChecklistHistogram}
        queryParams={queryParams}
        multiseriesApi={multiseriesApi}
        countLabel="Completions"
      />
      <Generic contentId={contentId} documentNodeId={documentNodeId} />
    </Stack>
  );
};
